<template>
  <div :class="['pop-progress-arc-component', { ready: ready }]">
    <svg class="progress-svg">
      <circle
        class="progress-arc progress-background"
        cx="150"
        cy="140"
        r="120"
        :stroke-dasharray="totalDashArray"
      />
      <circle
        class="progress-arc progress-foreground"
        cx="150"
        cy="140"
        r="120"
        :stroke-dasharray="progressDashArray"
      />
    </svg>
    <div
      v-if="ready"
      class="ready-reveal"
    >
      <span class="ready-text">
        Ready!
      </span>
      <span class="reveal-text">
        We're all set to reveal your odds
      </span>
      <button
        class="show-me-button"
        @click="showResults"
      >
        Show Me
      </button>
    </div>
    <div
      v-else
      class="questions-remaining"
    >
      <span class="questions-count">{{ questionsRemaining }}</span>
      <span class="remaining-text">questions to go before we calculate your odds.</span>
      <button
        class="more-info-button"
        @click="handleMoreInfoClick"
      >
        More Info
      </button>
    </div>
    <icon
      v-if="locked"
      name="lock"
      class="lock-icon"
    />
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
// Total px for arc
const TOTAL_DASH_ARRAY = 377;

export default {
  components: { Icon },
  props: {
    locked: {
      type: Boolean,
      default: true,
    },
    percent: {
      type: Number,
      default: 0,
    },
    questionsRemaining: {
      type: Number,
      default: 0,
    },
    ready: {
      type: Boolean,
    },
  },
  emits: ['fetch-results'],
  computed: {
    progressDashArray() {
      // Return a filled value if results are ready
      // This keeps the fill from overflowing
      if (this.ready) {
        return this.totalDashArray;
      } else {
        const progress = (this.percent / 100) * TOTAL_DASH_ARRAY;
        return `${progress}px ${TOTAL_DASH_ARRAY * 2}px`;
      }
    },
    totalDashArray() {
      return `${TOTAL_DASH_ARRAY}px`;
    },
  },
  methods: {
    handleMoreInfoClick() {
      this.$modal.show('pop-beta-modal');
      this.$analytics.events.viewedBetaScreen();
    },
    showResults() {
      this.$emit('fetch-results');
    },
  },
};
</script>

<style lang="scss" scoped>
.pop-progress-arc-component {
  height: 100%;
  padding: 12px 0;
  position: relative;

  .progress-svg {
    margin: 0 auto;

    .progress-arc {
      fill: transparent;
      stroke-width: 10px;
      stroke-linecap: round;
      transform-origin: 150px 140px;
      transform: rotate(-180deg);
      transition: ease-in-out .25s;

      &.progress-background {
        stroke: #bef7ff;
      }

      &.progress-foreground {
        stroke: #00dbfb;
      }
    }
  }

  .ready-reveal {
    text-align: center;
    margin-top: -75px;

    .ready-text {
      @include charter-black;
      display: block;
      font-size: rem-calc(40);
      font-weight: $bold;
    }

    .reveal-text {
      margin-top: rem-calc(8);
      display: block;
      font-size: rem-calc(12);
      line-height: 1.33;
    }

    .show-me-button {
      margin-top: 32px;
      padding: 10px 40px;
      background: #ffffff;
      border: 1px solid #000000;
      text-transform: uppercase;
      font-weight: $semi-bold;
      border-radius: 24px;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.26);
    }
  }

  .questions-remaining {
    max-width: rem-calc(175);
    margin: -75px auto 0;
    text-align: center;

    .questions-count {
      @include charter-black;
      display: block;
      font-size: rem-calc(40);
      font-weight: $bold;
    }

    .remaining-text {
      margin-top: rem-calc(8);
      display: block;
      font-size: rem-calc(12);
      line-height: 1.33;
    }

    .more-info-button {
      font-size: rem-calc(12);
      text-decoration: underline;
      margin-top: 24px;
      padding: 10px 40px;
      background: transparent;
      text-transform: uppercase;
      font-weight: $semi-bold;
      border-radius: 24px;
    }
  }

  .lock-icon {
    position: absolute;
    right: 8px;
    padding: rem-calc(3);
    width: rem-calc(9);
    height: rem-calc(9);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
